import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import { selectHasPermission } from '../features/auth/authSlice';

/**
 * Route/section guard: renders children only if the current (platform) user
 * holds `perm`. Otherwise shows a 403 notice. Pairs with the permission-filtered
 * menu in AdminLayout — the menu hides the link; this blocks direct-URL access.
 */
export const RequirePermission: React.FC<{ perm: string; children: React.ReactNode }> = ({
  perm,
  children,
}) => {
  const allowed = useAppSelector(selectHasPermission(perm));
  const navigate = useNavigate();

  if (!allowed) {
    return (
      <Result
        status="403"
        title="Not authorized"
        subTitle="You don't have permission to view this page."
        extra={
          <Button type="primary" onClick={() => navigate('/dashboard')}>
            Back to dashboard
          </Button>
        }
      />
    );
  }
  return <>{children}</>;
};

export default RequirePermission;
